import React, { useRef } from 'react';
import { Input } from './ui/input';

// Text input whose grey hint (e.g. "Cpl") can be adopted as the value: double-click the hint to
// drop it into the field, then edit normally. Single click just focuses the field.
export default function HintInput({ hint, value, onChange, onAccept, component: Comp = Input, className = '', ...props }) {
  const ref = useRef(null);
  const text = (hint || '').replace(/^e\.g\.\s*/i, '');
  const accept = () => {
    if (onAccept) onAccept(text);
    else if (onChange) onChange({ target: { value: text } });
    setTimeout(() => ref.current && ref.current.focus(), 0);
  };
  return (
    <div className="relative">
      <Comp ref={ref} value={value || ''} onChange={onChange} className={className} {...props} placeholder="" />
      {!value && hint && (
        <span role="button" tabIndex={-1} onClick={() => ref.current && ref.current.focus()} onDoubleClick={accept}
          title="Double-click to use this suggestion" data-testid={`${props['data-testid'] || 'hint'}-hint`}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-sm select-none cursor-text truncate max-w-[85%]" style={{ color: 'rgba(0,0,0,0.38)' }}>
          {hint}
        </span>
      )}
    </div>
  );
}
